import { tryGetGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getBposNavBarData } from 'owa-bpos-store';
import { getAccountKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';
import getAttachmentPolicy from 'owa-session-store/lib/utils/getAttachmentPolicy';

export function getOneDriveForBusinessAvailability(
    mailboxInfo: MailboxInfo,
    useAccountSpecificNavBarData: boolean = false
): {
    hasAttachmentProvider: boolean | undefined;
    hasBPOSNavBarData: boolean;
    hasOneDriveForBusiness: boolean;
} {
    const hasAttachmentProvider = getAttachmentPolicy(mailboxInfo)?.AttachmentDataProviderAvailable;
    const globalAccountMailboxInfo = useAccountSpecificNavBarData
        ? tryGetGlobalSettingsAccountMailboxInfo(false)
        : undefined;
    const useAccountNavBar =
        useAccountSpecificNavBarData &&
        (!globalAccountMailboxInfo ||
            getAccountKeyForMailboxInfo(globalAccountMailboxInfo) !==
                getAccountKeyForMailboxInfo(mailboxInfo));
    const hasBPOSNavBarData = !!getBposNavBarData(useAccountNavBar ? mailboxInfo : undefined)
        ?.SPO_RootSiteUrl;

    return {
        hasAttachmentProvider,
        hasBPOSNavBarData,
        hasOneDriveForBusiness: !!hasAttachmentProvider || hasBPOSNavBarData,
    };
}
